<template>
  <div v-if="tablePagination && tablePagination.last_page > 1" :class="css.wrapperClass">
     <ul :class="[css.ulClass]">
        <a @click="loadPage(1)"
          :class="['btn-nav', css.linkClass, isOnFirstPage ? css.disabledClass : '']">
            <i v-if="css.icons.first != ''" :class="[css.icons.first]"></i>
            <span v-else>&laquo;</span>
        </a>
        <a @click="loadPage('prev')"
          :class="['btn-nav', css.linkClass, isOnFirstPage ? css.disabledClass : '']">
            <i v-if="css.icons.next != ''" :class="[css.icons.prev]"></i>
            <span v-else>&nbsp;&lsaquo;</span>
        </a>
        <template v-if="notEnoughPages">
          <template v-for="n in totalPage">
            <li :class="[css.pageClass, isCurrentPage(windowStart+n-1) ? css.activeClass : '']"><a @click="loadPage(n)"
              :class="[css.linkClass, isCurrentPage(n) ? css.activeClass : '']"
              v-html="n">
            </a>
            </li>
          </template>
        </template>
        <template v-else>
          <template v-for="n in windowSize">
            <li :class="[css.pageClass, isCurrentPage(windowStart+n-1) ? css.activeClass : '']"><a @click="loadPage(windowStart+n-1)"
             :class="[css.linkClass]" v-html="windowStart+n-1">
            </a>
            </li>
          </template>
        </template>
        <a @click="loadPage('next')"
          :class="['btn-nav', css.linkClass, isOnLastPage ? css.disabledClass : '']">
          <i v-if="css.icons.next != ''" :class="[css.icons.next]"></i>
          <span v-else>&rsaquo;&nbsp;</span>
        </a>
        <a @click="loadPage(totalPage)"
          :class="['btn-nav', css.linkClass, isOnLastPage ? css.disabledClass : '']">
          <i v-if="css.icons.last != ''" :class="[css.icons.last]"></i>
          <span v-else>&raquo;</span>
        </a>
    </ul>
  </div>
</template>

<script>
import PaginationMixin from './VuetablePaginationMixin.vue'

export default {
  mixins: [PaginationMixin],
}
</script>
